import { useEffect, useState } from "react";
import { Divider, Dropdown, Message } from "semantic-ui-react";
import { useRestClientContext } from "../contexts/RestClientContext";
import { useTeamContext } from "../contexts/TeamContext";
import PowerBiReportEmbed from "../components/Reports/PowerBiReportEmbed";
import Preloader from "../components/UI/Preloader/Preloader";
import { Report } from "../types/reports";
import Page from "./Page";
import "./ReportsPage.scss";

export default function ReportsPage() {
	const client = useRestClientContext();
	const team = useTeamContext();
	const [reports, setReports] = useState<Report[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [selectedReportId, setSelectedReportId] = useState<number | null>(null);

	useEffect(() => {
		setIsLoading(true);
		setError(null);

		client.v3
			.fetchReports(team)
			.then((data: Report[]) => {
				setReports(data);
				if (data.length > 0) {
					setSelectedReportId(data[0].id);
				}
			})
			.catch((err: Error) => setError(err.message ?? "Failed to load reports"))
			.finally(() => setIsLoading(false));
	}, [client, team]);

	const reportOptions = reports.map((report) => ({ key: report.id, value: report.id, text: report.title }));

	return (
		<Page className="reports">
			<div className="reports-header">
				<div className="reports-selector">
					{/* Show loading/errors. If all ok then show dropdown unless there is only one option. */}
					{isLoading ? (
						<Preloader />
					) : error ? (
						<Message error>{error}</Message>
					) : reports.length === 0 ? (
						<Message warning>No reports are available.</Message>
					) : reports.length > 1 ? (
						<>
							<label htmlFor="report-selector">Choose a Dashboard</label>
							<Divider />
							<Dropdown
								id="report-selector"
								selection
								options={reportOptions}
								value={selectedReportId ?? undefined}
								onChange={(_, { value }) => setSelectedReportId(value as number)}
							/>
						</>
					) : null}
				</div>
			</div>

			{selectedReportId !== null && (
				<div className="reports-embed-card">
					<PowerBiReportEmbed reportId={selectedReportId} />
				</div>
			)}
		</Page>
	);
}
